/* global Swiper */
(() => {
	// ============================================
	// 共通変数
	// ============================================
	//メディアクエリ
	const breakPointPc = 768;
	const mql = window.matchMedia(`(min-width: ${breakPointPc}px)`);

	// ============================================
	// スライダー
	// ============================================
	const swiperInit = () => {
		// Swiperを先に生成（autoplayは停止状態で）
		new Swiper('.swiper', {
			loop: true,
			speed: 1000,
			watchOverflow: true,
			slidesPerView: 'auto',
			centeredSlides: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	};

	// ============================================
	// アコーディオン
	// ============================================
	const accordionInit = () => {
		//処理
		const checkWindow = (e) => {
			const commonName = 'data-accordion';
			const accordionWrap = `${commonName}-wrap`;
			const accordionTrigger = `${commonName}-trigger`;
			const accordionTarget = `${commonName}-target`;
			const duration = 300; //アニメーションする秒数

			//プロパティ追加
			const addStyle = (target, slideDown = false) => {
				if (!target) return;
				target.style.height = 0;
				target.style.paddingTop = 0;
				target.style.paddingBottom = 0;
				target.style.marginTop = 0;
				target.style.marginBottom = 0;

				if (slideDown === true) {
					void target.offsetHeight; //slideDownのみ
				}
				target.style.transitionProperty = 'height, margin, padding';
				target.style.transitionDuration = duration + 'ms';
				target.style.transitionTimingFunction = 'ease';
				target.style.overflow = 'hidden';
			};

			//プロパティ削除
			const removeProperty = (target) => {
				if (!target) return;
				target.style.removeProperty('height');
				target.style.removeProperty('padding-top');
				target.style.removeProperty('padding-bottom');
				target.style.removeProperty('margin-top');
				target.style.removeProperty('margin-bottom');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
				target.style.removeProperty('transition-timing-function');
				delete target.dataset.accordionState; //フラグをfalseに変更
			};

			//クラス付け替え
			const toggleClass = (target, trigger) => {
				if (!target || !trigger) return;

				const parent = target.closest(`[${commonName}-wrap]`);
				const openClass = parent.dataset.accordionWrap;
				if (!openClass) return; //値がなければスルー

				target.classList.toggle(openClass);
				trigger.classList.toggle(openClass);
			};

			//アコーディオン閉じる
			const slideUp = (trigger, target) => {
				if (target.dataset.accordionState === 'true') return; //既に実行中の場合は何もしない
				target.dataset.accordionState = 'true'; //フラグをtrueに変更

				target.style.height = target.offsetHeight + 'px'; //元の高さを追加
				void target.offsetHeight;
				addStyle(target);

				setTimeout(() => {
					toggleClass(target, trigger); //クラス付け替え
					removeProperty(target); //スタイル削除
				}, duration);
			};

			//アコーディオン開く
			const slideDown = (trigger, target) => {
				if (target.dataset.accordionState === 'true') return;
				target.dataset.accordionState = 'true';

				toggleClass(target, trigger);

				let height = target.offsetHeight;
				addStyle(target, true);
				target.style.height = height + 'px';

				setTimeout(() => {
					removeProperty(target);
				}, duration);
			};

			// 初期表示でアコーディオンを開く（PCのみ）
			const openAccordion = (target, trigger, wrap) => {
				if (!target || !trigger || !wrap) return;

				// 既に初期処理済みなら何もしない
				if (wrap.dataset.accordionInitialized === 'true') return;

				const openClass = wrap.dataset.accordionWrap;
				if (!openClass) return;

				target.classList.add(openClass);
				trigger.classList.add(openClass);

				// 初期処理済みフラグ
				wrap.dataset.accordionInitialized = 'true';
			};

			// アコーディオンをリセット（SPのみ）
			const resetAccordion = (target, trigger, wrap) => {
				if (!target || !trigger || !wrap) return;

				const openClass = wrap.dataset.accordionWrap;
				if (!openClass) return;

				target.classList.remove(openClass);
				trigger.classList.remove(openClass);

				// 初期化フラグをリセット
				delete wrap.dataset.accordionInitialized;
			};

			//アコーディオン開閉
			const slideToggle = (trigger, target) => {
				const parent = target.closest(`[${commonName}-wrap]`);
				const openClass = parent.dataset.accordionWrap;

				if (!target.classList.contains(openClass)) {
					return slideDown(trigger, target);
				} else {
					return slideUp(trigger, target);
				}
			};

			//処理
			if (!document.querySelectorAll(`[${accordionWrap}]`).length) return;

			document.querySelectorAll(`[${accordionWrap}]`).forEach((wrap) => {
				const wrapTarget = wrap.querySelector(`[${accordionTarget}]`);
				const wrapTrigger = wrap.querySelector(`[${accordionTrigger}]`);

				if (!wrapTrigger || !wrapTarget) return; //要素がなければスルー

				//data-accordion-open="true"の場合＋PC時のみ
				if (e ? e.matches : mql.matches) {
					if (wrap.dataset.accordionOpen === 'true') {
						openAccordion(wrapTarget, wrapTrigger, wrap);
					}
				} else {
					// SP時は全て閉じる
					resetAccordion(wrapTarget, wrapTrigger, wrap);
				}

				//クリック処理（多重登録防止）
				if (!wrap.dataset.accordionClickBound) {
					wrapTrigger.addEventListener('click', () => {
						slideToggle(wrapTrigger, wrapTarget);
					});
					wrap.dataset.accordionClickBound = 'true';
				}
			});
		};

		// ロード時に判定
		checkWindow(mql);
		// ブレイクポイントが切り替わったら判定
		mql.addEventListener('change', checkWindow);
	};

	// ============================================
	// PCで<br>と半角スペースを削除(よくある質問)
	// ============================================
	const formatText = () => {
		//処理
		const checkWindow = (e) => {
			const isPc = e ? e.matches : mql.matches; // PC判定
			const questions = document.querySelectorAll('[data-format-target]'); //対象

			questions.forEach((question) => {
				// 元のHTMLを保存し、切り替え時に戻せるようにする
				if (!question.dataset.originalHtml) {
					question.dataset.originalHtml = question.innerHTML;
				}

				// PC
				if (isPc) {
					let text = question.dataset.originalHtml;
					text = text.replace(/<br\s*\/?>/gi, ''); // <br>タグを削除
					text = text.replace(/[\r\n]/g, ''); // 改行コードを削除
					text = text.replace(/ /g, ''); // 半角スペースを削除
					question.innerHTML = text; // HTMLに反映
				} else {
					// スマホは戻す
					question.innerHTML = question.dataset.originalHtml;
				}
			});
		};
		// ロード時に判定
		checkWindow(mql);
		// ブレイクポイントが切り替わったら判定
		mql.addEventListener('change', checkWindow);
	};

	// ============================================
	// スクロールアニメーション
	// ============================================
	const scrollAnimation = () => {
		const dataAttrPref = 'data-fadeIn';

		// 各種data属性対象
		const fadeInTargets = document.querySelectorAll(`[${dataAttrPref}-target], [${dataAttrPref}-target-delay]`);
		if (fadeInTargets.length === 0) return; // フェードイン対象要素がない場合はスルー

		// アニメーション追加用クラス
		const fadeInClass = 'is-fade-in-active'; // 通常アニメーション用クラス名

		// IntersectionObserver設定
		const fadeInOptions = {
			root: null,
			rootMargin: '0px 0px -15% 0px', // 画面の下から15%の位置に来たらアニメーション発火
			threshold: 0,
		};

		// フェードイン対象全要素に監視を設定
		fadeInTargets.forEach((target) => {
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return; //要素がなければスルー

					// 通常フェードイン
					if (target.hasAttribute(`${dataAttrPref}-target`)) {
						target.classList.add(fadeInClass);
					}

					// グループ制御
					const group = target.closest(`[${dataAttrPref}-group]`);
					if (group) {
						const fadeInElem = group.querySelector('[data-fadeIn-target]');
						const delayElem = group.querySelector('[data-fadeIn-target-delay]');

						if (fadeInElem && delayElem) {
							fadeInElem.addEventListener(
								'animationend',
								(event) => {
									delayElem.classList.add(fadeInClass);
								},
								{ once: true } // 1度だけ実行
							);
						}
					}
					observer.unobserve(entry.target);
				});
			}, fadeInOptions);

			observer.observe(target);
		});
	};

	// ============================================
	// 実行
	// ============================================
	swiperInit();
	accordionInit();
	formatText();
	scrollAnimation();
})();
